// @prepros-prepend "../../../node_modules/accordion-js/dist/accordion.js";

import { menu } from './modules/menu'
import { slider } from './modules/slider'
import { objectsearch } from './modules/objectsearch'
import { regex } from './modules/regex'

$(document).ready(function () {
	new WOW().init()
	
	slider()
	menu()
	objectsearch()
	regex()
	
	if ($('.accordions').length) {
		$('.accordions').each(function () {
			new Accordion($(this)[0])
		})
	}

	$("#cta-jump").on("click", function(e) {
		e.preventDefault();

		var headerHeight = $("#header").outerHeight();
		var topOffset = $('.section--cta').offset().top - headerHeight;

		$('html, body').animate({scrollTop: topOffset}, 500);
	})
	
})
